import "./bootstrap";
import "../sass/app.scss";

import Swiper from "swiper";

import { Navigation } from "swiper/modules";
// import Swiper and modules styles
import "swiper/swiper-bundle.min.css";

document.addEventListener("DOMContentLoaded", function () {
    ////////////////////
    ////   LAZYLOAD  ///
    ////////////////////

    lazyload();

    /// MENU TOGGLE

    const menuToggle = document.querySelector(".menu-toggle");
    const cross = document.querySelector(".cross");
    const headerMenu = document.querySelector(".header-menu");

    if (menuToggle && cross && headerMenu) {
        menuToggle.addEventListener("click", function () {
            headerMenu.classList.toggle("header-menu-open");
        });

        cross.addEventListener("click", function () {
            headerMenu.classList.remove("header-menu-open");
        });

        document.addEventListener("click", function (event) {
            const isClickInside =
                headerMenu.contains(event.target) ||
                menuToggle.contains(event.target);

            if (!isClickInside) {
                headerMenu.classList.remove("header-menu-open");
            }
        });
    }

    /// MARQUEE

    function isSafari() {
        return (
            /Safari/.test(navigator.userAgent) &&
            !/Chrome|CriOS|Android/.test(navigator.userAgent) &&
            /Version/.test(navigator.userAgent)
        );
    }

    function setupMarquee(marquee, marqueeWrapper, marqueeContent) {
        setTimeout(() => {
            const contentWidth = marqueeContent.offsetWidth;
            const speedFactor = 50; // Lower value = faster speed
            const duration = contentWidth / speedFactor;

            if (isSafari()) {
                // Safari-specific: use requestAnimationFrame animation
                let startTime = null;

                function animateMarquee(timestamp) {
                    if (!startTime) startTime = timestamp;
                    const elapsed = timestamp - startTime;

                    // Calculate current position based on elapsed time
                    const position =
                        (elapsed / 1000) * (contentWidth / duration);

                    // Move the content based on the current position
                    marqueeWrapper.style.transform = `translateX(${-position}px)`;

                    // Reset the animation once it completes one full cycle
                    if (position >= contentWidth) {
                        startTime = timestamp; // Restart animation
                    }

                    // Continue the animation
                    requestAnimationFrame(animateMarquee);
                }

                // Start the animation
                requestAnimationFrame(animateMarquee);
            } else {
                // Non-Safari browsers: use CSS animation

                marquee.style.setProperty(
                    "--innermarquee",
                    "calc((0.9rem + " + contentWidth + "px) * -1)",
                );

                marqueeWrapper.setAttribute(
                    "style",
                    "animation: marqueeAnimation linear infinite " +
                        duration +
                        "s; -webkit-animation: marqueeAnimation linear infinite " +
                        duration +
                        "s",
                );
            }
        }, 100);
    }

    const marquees = document.querySelectorAll(".marquee");

    marquees.forEach((marquee) => {
        const marqueeWrapper = marquee.querySelector(".marquee-wrapper");
        const marqueeContent = marquee.querySelector(".marquee-content");

        if (marqueeContent && marqueeWrapper && marquee) {
            setupMarquee(marquee, marqueeWrapper, marqueeContent);
        }
    });

    //// SWIPER

    const swiper = new Swiper(".swiper-container", {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-btn-next, .swiper-arrow-next",
            prevEl: ".swiper-btn-prev, .swiper-arrow-prev",
        },
        on: {
            init: function () {
                const currentIndex = this.realIndex + 1;
                const totalSlides = this.slides.length; // Adjust for duplicated slides in loop mode
                document.querySelector(
                    ".swiper-index",
                ).innerHTML = `${currentIndex}/${totalSlides}`;
            },
            slideChange: function () {
                const currentIndex = this.realIndex + 1;
                const totalSlides = this.slides.length; // Adjust for duplicated slides in loop mode
                document.querySelector(
                    ".swiper-index",
                ).innerHTML = `${currentIndex}/${totalSlides}`;
            },
        },
    });

    // Helper function to initialize Swiper
    const initializeSwiper = (container) => {
        const swiperId = container.getAttribute("data-id");

        // Find navigation elements
        const prevButton = document.getElementById(`prev-${swiperId}`);
        const nextButton = document.getElementById(`next-${swiperId}`);
        const indexElement = document.getElementById(`index-${swiperId}`);

        if (!prevButton) {
            console.error(`Prev button not found for Swiper ${swiperId}.`);
        }
        if (!nextButton) {
            console.error(`Next button not found for Swiper ${swiperId}.`);
        }
        if (!indexElement) {
            console.error(`Index element not found for Swiper ${swiperId}.`);
        }

        if (!prevButton || !nextButton || !indexElement) {
            console.error(
                `Skipping initialization for Swiper ${swiperId} due to missing elements.`,
            );
            return;
        }

        try {
            const swiperInstance = new Swiper(container, {
                modules: [Navigation],
                slidesPerView: "auto",
                spaceBetween: 10,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                on: {
                    init: function () {
                        const currentIndex = this.realIndex + 1;
                        const totalSlides = this.slides.length;
                        indexElement.textContent = `${currentIndex}/${totalSlides}`;
                    },
                    slideChange: function () {
                        const currentIndex = this.realIndex + 1;
                        const totalSlides = this.slides.length;
                        indexElement.textContent = `${currentIndex}/${totalSlides}`;
                    },
                },
            });
        } catch (error) {
            console.error(`Swiper setup failed for ${swiperId}:`, error);
        }
    };

    // Initialize Swipers on all containers

    const swiperContainers = document.querySelectorAll(
        ".custom-swiper-container",
    );
    swiperContainers.forEach(initializeSwiper);

    // Function to toggle the section navigation
    function toggleSectionNav(event) {
        const button = event.currentTarget;
        const sectionNavList = button
            .closest(".header-nav-list-li") // Closest li element
            .querySelector(".section-nav-list"); // Find the corresponding section-nav-list in this li

        // Close all other open sections
        const allButtons = document.querySelectorAll(".toggle-sections");
        const allSectionNavLists =
            document.querySelectorAll(".section-nav-list");

        // Loop through all toggle buttons and close them if they are not the one being clicked
        allButtons.forEach((otherButton) => {
            if (otherButton !== button) {
                otherButton.classList.remove("toggle-sections--open");
            }
        });

        // Loop through all section nav lists and close them if they are not the one being clicked
        allSectionNavLists.forEach((otherSectionNavList) => {
            if (otherSectionNavList !== sectionNavList) {
                otherSectionNavList.classList.remove("section-nav-list--open");
                otherSectionNavList.style.setProperty("--innerHeight", "0px");
            }
        });

        // Toggle the open state of the clicked section
        button.classList.toggle("toggle-sections--open");

        if (sectionNavList) {
            sectionNavList.classList.toggle("section-nav-list--open");

            // Calculate and set the height
            const innerHeight = sectionNavList.scrollHeight;
            sectionNavList.style.setProperty(
                "--innerHeight",
                `${innerHeight}px`,
            );
        }
    }

    // Attach event listeners to all buttons with the class 'toggle-sections'
    const toggleButtons = document.querySelectorAll(".toggle-sections");
    toggleButtons.forEach((button) => {
        button.addEventListener("click", toggleSectionNav);
    });

    //// SPECTACLES FILTERING

    const filterButtons = document.querySelectorAll(".spectacles__nav__btn");
    const spectacleItems = document.querySelectorAll(".spectacles__item");

    function filterItems(filter) {
        spectacleItems.forEach((item) => {
            const itemPlace = item.getAttribute("data-place");
            if (filter === "all" || itemPlace === filter) {
                item.style.display = "flex";
            } else {
                item.style.display = "none";
            }
        });
    }

    filterButtons.forEach((button) => {
        button.addEventListener("click", function () {
            // Toggle selected class
            const isSelected = this.classList.contains(
                "spectacles__nav__btn--selected",
            );
            filterButtons.forEach((btn) =>
                btn.classList.remove("spectacles__nav__btn--selected"),
            );

            if (!isSelected) {
                // If not selected, filter the items based on data-place
                this.classList.add("spectacles__nav__btn--selected");
                const filter = this.getAttribute("data-filter");
                filterItems(filter);

                // Update the URL with the filter slug, properly formatted
                history.pushState(null, "", `#${filter}`);
            } else {
                // If selected, show all items and reset URL
                filterItems("all");
                history.pushState(null, "", window.location.pathname);
            }
            if (this.getAttribute("data-filter") == "all") {
                this.classList.add("spectacles__nav__btn--selected");
                filterItems("all");
                history.pushState(null, "", window.location.pathname);
            }
        });
    });

    // On page load, check if there is a hash in the URL to filter
    const currentHash = window.location.hash.substring(1);
    if (currentHash) {
        const activeButton = Array.from(filterButtons).find(
            (button) => button.getAttribute("data-filter") === currentHash,
        );
        if (activeButton) {
            activeButton.classList.add("spectacles__nav__btn--selected");
            filterItems(currentHash);
        }
    }

    ///// HEADER STATE

    window.onscroll = function () {
        removeHeaderClass();
    };

    function removeHeaderClass() {
        const header = document.querySelector(".header");

        // Check if the page is scrolled more than 20px
        if (window.scrollY > 20) {
            header.classList.remove("header--big"); // Replace 'your-class' with the class you want to remove
        } else {
            header.classList.add("header--big");
        }
    }

    ///// LOGO ANIMATION

    setTimeout(() => {
        document.querySelector(".logo").classList.add("logo-symbol");
    }, 2000);

    document.querySelector(".logo").addEventListener("mouseover", () => {
        document.querySelector(".logo").classList.remove("logo-symbol");
    });

    document.querySelector(".logo").addEventListener("mouseout", () => {
        document.querySelector(".logo").classList.add("logo-symbol");
    });

    ///// FORM CONDITIONAL

    // Get all form__wrapper elements that contain a form__conditional element
    var wrappers = document.querySelectorAll(".form__wrapper");

    wrappers.forEach(function (wrapper) {
        var conditionalCheckbox = wrapper.querySelector(
            ".form__conditional .form__checkbox",
        );

        if (conditionalCheckbox) {
            var inputs = wrapper.querySelectorAll(".form__input");

            // Initially hide all form__input elements
            inputs.forEach(function (input) {
                input.style.display = "none";
            });

            // Add event listener to the checkbox
            conditionalCheckbox.addEventListener("change", function () {
                if (conditionalCheckbox.checked) {
                    // Show all form__input elements when checkbox is checked
                    inputs.forEach(function (input) {
                        input.style.display = "block";
                    });
                } else {
                    // Hide all form__input elements when checkbox is unchecked
                    inputs.forEach(function (input) {
                        input.style.display = "none";
                    });
                }
            });

            // Trigger the change event on page load in case the checkbox is pre-checked
            conditionalCheckbox.dispatchEvent(new Event("change"));
        }
    });

    ///// CALENDAR BLOCK

    const scheduleBlock = document.querySelector(".home-block-schedule");
    if (scheduleBlock) {
        document.body.addEventListener("click", function (event) {
            // Only proceed if the button is not disabled
            if (
                (event.target.matches(".prev-week") || event.target.matches(".next-week")) &&
                !event.target.disabled
            ) {
                event.preventDefault();
                let direction = event.target.matches(".prev-week")
                    ? "prev"
                    : "next";
                updateWeek(direction);
            }
        });

        function updateWeek(direction) {
            if (typeof weeklyScheduleData === 'undefined') {
                console.error('Weekly schedule data is not properly initialized');
                return;
            }

            const scheduleContainer = document.querySelector(".home-block-schedule");
            const weekRangeElement = document.querySelector(".week-range");
            const weekStart = weekRangeElement.getAttribute("data-start");
            
            // Add loading states
            scheduleContainer.classList.add("loading");
            weekRangeElement.classList.add("loading");
            
            // Disable only the clicked button during loading
            const clickedButton = scheduleContainer.querySelector(`.${direction}-week`);
            clickedButton.disabled = true;

            fetch(weeklyScheduleData.ajaxurl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
                body: new URLSearchParams({
                    action: "load_weekly_schedule",
                    nonce: weeklyScheduleData.nonce,
                    week_start: weekStart,
                    direction: direction,
                }),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // Create a temporary div to hold the new content
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = data.data.html;
                        
                        // Replace the old content with the new one
                        scheduleContainer.replaceWith(tempDiv.firstElementChild);
                    } else {
                        throw new Error(data.data ? data.data.message : 'Unknown error');
                    }
                })
                .catch(error => {
                    console.error("Error:", error);
                    clickedButton.disabled = false;
                    scheduleContainer.classList.remove("loading");
                    weekRangeElement.classList.remove("loading");
                });
        }
    }

    /// PREHOME ANIMATION

    const prehomeLogo = document.querySelectorAll(".prehome__logo");
    const prehome = document.querySelector(".prehome");
    const clipPath = document.querySelector("#customClipPath");
    const bodyHome = document.querySelector("body.home");
    const mainHome = document.querySelector(".home main");
    const imgEffect = document.querySelectorAll(
        ".home-block-spectacle-img-effect",
    );

    if (bodyHome) {
        if (!localStorage.getItem("animationShown")) {
            setTimeout(() => {
                prehomeLogo[0].setAttribute("style", "transform: scale(35)");
            }, 500);
            setTimeout(() => {
                prehomeLogo[1].setAttribute("style", "transform: scale(35)");
            }, 1000);
            setTimeout(() => {
                clipPath.setAttribute(
                    "style",
                    "transform: translate(calc(50vw - 74px), calc(50dvh - 156.5px)) scale(35);",
                );
            }, 1500);
            setTimeout(() => {
                bodyHome.setAttribute("style", "height:auto");
            }, 3000);
            setTimeout(() => {
                mainHome.setAttribute("style", "clip-path:none");
            }, 3000);
            setTimeout(() => {
                imgEffect.forEach((element) => {
                    element.setAttribute("style", "display:block");
                });
            }, 3000);

            // Store a flag in localStorage to indicate the animation has been shown
            localStorage.setItem("animationShown", "true");
        } else {
            bodyHome.setAttribute("style", "height:auto");
            mainHome.setAttribute("style", "clip-path:none");
            prehome.setAttribute("style", "display:none");
            imgEffect.forEach((element) => {
                element.setAttribute("style", "display:block");
            });
        }
    }

    ///////// FOCUS ON INPUT SEARCH PAGE
    if (document.querySelector(".searchpage__input")) {
        document.querySelector(".searchpage__input").focus();
    }

    ///////// LOAD MORE DATES ON MOBILE :

    const datesColumn = document.querySelector(".spectacle-column-dates");
    const datesColumnMore = document.querySelector(
        ".spectacle-column-dates-more",
    );

    if (datesColumn && datesColumnMore) {
        datesColumnMore.addEventListener("click", function () {
            const innerHeight = datesColumn.scrollHeight; // Get the full inner height
            datesColumn.style.height = innerHeight + "px"; // Apply the height to .spectacle-column-dates
            datesColumnMore.classList.add(
                "spectacle-column-dates-more--clicked",
            );
        });
    }

    ///////// FOCUS ON INPUT SEARCH PAGE

    tarteaucitron.init({
        privacyUrl: "" /* Privacy policy url */,
        bodyPosition:
            "bottom" /* or top to bring it as first element for accessibility */,

        hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
        cookieName: "tarteaucitron" /* Cookie name */,

        orientation:
            "middle" /* Banner position (top - bottom - middle - popup) */,

        groupServices: false /* Group services by category */,
        showDetailsOnClick: true /* Click to expand the description */,
        serviceDefaultState: "wait" /* Default state (true - wait - false) */,

        showAlertSmall: false /* Show the small banner on bottom right */,
        cookieslist: false /* Show the cookie list */,

        showIcon: true /* Show cookie icon to manage cookies */,
        // "iconSrc": "", /* Optional: URL or base64 encoded image */
        iconPosition:
            "BottomRight" /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */,

        adblocker: false /* Show a Warning if an adblocker is detected */,

        DenyAllCta: true /* Show the deny all button */,
        AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
        highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,
        alwaysNeedConsent: false /* Ask the consent for "Privacy by design" services */,

        handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

        removeCredit: false /* Remove credit link */,
        moreInfoLink: true /* Show more info link */,
        useExternalCss: false, /* Change this to true to load the external CSS */
        useExternalJs: false /* If false, the tarteaucitron.services.js file will be loaded */,

        // "cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */

        readmoreLink:
            "" /* Change the default readmore link pointing to tarteaucitron.io */,

        mandatory: true /* Show a message about mandatory cookies */,
        mandatoryCta: true /* Show the disabled accept button when mandatory on */,

        // "customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */

        googleConsentMode: true /* Enable Google Consent Mode v2 for Google ads and GA4 */,

        partnersList: false /* Details the number of partners on the popup and middle banner */,
    });

    /* end of DOM LOADED condition */
});
